import { CellphoneCogIcon } from './CellphoneCogIcon';

/**
 * author: Google
 * id 134C82D3-528D-46FA-9107-7F3D5AD8FBC3
 * name cellphone-cog
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-cog.svg
 * tags
 * - Settings 
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const SmartphoneSettingsVariantIcon = CellphoneCogIcon;
export default SmartphoneSettingsVariantIcon